// extracted by mini-css-extract-plugin
export default {"contactDetailsCard":"u7nrVu0deQaoB3y2Nsel","deprecatedNoPaddingGrid":"seQZIoW8DlObbr4TaVjc"};